import { render } from "./PortalVersionSwitch.vue?vue&type=template&id=f49a55cc"
import script from "./PortalVersionSwitch.vue?vue&type=script&lang=js"
export * from "./PortalVersionSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__